import React, { useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';
const ListAllActivitiesPage = loadable(() => import('./ListAllActivitiesPage'), {
    fallback: <Loader/>,
});
// Socket
import { io } from 'socket.io-client';
const socketURL = process.env.MIX_COMMON_SOCKET_URL ?? 'https://technource.co.in:3003';
const socket = io(socketURL, {
  transports: ['websocket', 'polling'], // Optional: ensure WebSocket is used
  secure: true, // Optional: ensure SSL/TLS
  query: {
    t: Date.now()
  }
});
const AllActivityRoute = ({ t }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListAllActivitiesPage t={t} socket={socket} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
AllActivityRoute.propTypes = {
  t: PropTypes.func
};
export default AllActivityRoute;
